<template>
  <span class="blur-reveal-element" ref="blurElement">
    <span
      v-for="(word, index) in words"
      :key="index"
      class="word"
      :class="{ 'revealed': revealedWords.includes(index) }"
    >
      {{ word }}
    </span>
  </span>
</template>

<script>
export default {
  props: ["text", "onFinish"],
  data() {
    return {
      words: [],
      revealedWords: [],
      staggerDelay: 50,
    };
  },
  mounted() {
    this.words = this.splitIntoWords(this.text);
    
    this.animateWords();
  },
  methods: {
    splitIntoWords(text) {
      if (!text) return [];

      return text.split(" ");
    },
    animateWords() {
      this.words.forEach((word, index) => {
        setTimeout(() => {
          this.revealedWords.push(index);
          if (index === this.words.length - 1) {
            setTimeout(() => {
              this.$emit("onFinish");
            }, 600);
          }
        }, index * this.staggerDelay);
      });
    },
  },
};
</script>

<style>
.blur-reveal-element {
  display: inline-block;
}

.word {
  display: inline-block;
  margin-right: 0.25em;
  margin-bottom: 0.25em;
  filter: blur(8px);
  opacity: 0;
  transition: filter 0.6s ease-out, opacity 0.6s ease-out;
}

.word.revealed {
  filter: blur(0);
  opacity: 1;
}
</style>